import { GET_GUIDEWAY_PIECE_SIZE_CSTIC_NAME } from "~/features/configurator/Linear/constants";
import { getDirtyParamName } from "~/features/configurator/Linear/namingUtils";

import { type KmatType } from "~/features/configurator/Linear/kmatType";

export const getGuidewayPieceDirtyParamName = (type: KmatType, kmatIndex: number, pieceIndex: number) => {
  return getDirtyParamName({
    key: GET_GUIDEWAY_PIECE_SIZE_CSTIC_NAME(pieceIndex),
    index: kmatIndex,
    type: type,
  });
};
